import creditsafeCompanySearchInput from './creditsafeCompanySearchInput';

export default class CreditsafeCompanySearch {
	constructor(creditsafeCompanySearchForm) {
		this.address1Container = document.getElementById('address1Container');
		this.address2Container = document.getElementById('address2Container');
		this.creditsafeCompanySearchForm = creditsafeCompanySearchForm;
		this.billingForm = document.getElementById('billingForm');
		this.countrySelector = document.getElementById('countrySelection');
		this.searchBarInput = document.getElementById('searchBarInput');
		this.buttonBackToSearch = document.getElementById('buttonBackToSearch');
		this.enterDataManuallyButton = document.getElementById(
			'enterDataManuallyButton',
		);
		this.enterDataManuallyOnListButton = document.getElementById(
			'enterDataManuallyOnListButton',
		);
		this.foundCompanyContainer = document.getElementById(
			'foundCompanyContainer',
		);
		this.companyNameContainer = document.getElementById('companyNameContainer');
		this.foundAddressCreditsafe = document.getElementById(
			'foundAddressCreditsafe',
		);
		this.addressManualEntry = document.getElementById(
			'enterAddressManualEntry',
		);
		this.postalCodeAndTownContainer = document.getElementById(
			'postalCodeAndTownContainer',
		);
		this.addressCardContainer = document.getElementById('addressCardContainer');
		this.companyNameValue = document.getElementById('companyName');
		this.chamberOfCommerceIdValue = document.getElementById(
			'chamberOfCommerceId',
		);
		this.creditSafeConnectIdValue = document.getElementById(
			'creditSafeConnectId',
		);
		this.creditCheckedCompanyIdValue = document.getElementById(
			'creditCheckedCompanyId',
		);
		this.sicIdValue = document.getElementById('sicId');
		this.validAddressValue = document.getElementById('validAddressId');
		this.validCompanyValue = document.getElementById('validCompanyId');
		this.companyTaxNumberValue = document.getElementById('companyTaxNumber');
		// The VAT (companyTaxNumber) field is rendered once inside the manual
		// company-details block. For the Creditsafe "found company" view it must be
		// shown inside #foundCompaniesContainerView (CH design), so we relocate the
		// single field node between its original location and the found-view slot
		// instead of rendering a duplicate (which would break the shared
		// getElementById('companyTaxNumber') contract used here and in
		// registrationBillingForm.js).
		this.companyTaxNumberGroup =
			this.companyTaxNumberValue?.closest('.form-group');
		this.companyTaxNumberOriginalParent =
			this.companyTaxNumberGroup?.parentElement;
		this.foundCompanyTaxNumberSlot = document.getElementById(
			'foundCompanyTaxNumberSlot',
		);
		this.addressValidationContainer = document.getElementById(
			'addressValidationContainerBlock',
		);
		this.chamberOfCommerceIdContainer = document.getElementById(
			'chamberOfCommerceIdContainer',
		);
		this.foundCompanyNameCreditsafe = document.getElementById(
			'foundCompanyNameCreditsafe',
		);
		this.address1Value = document.getElementById('address1');
		this.postalCodeValue = document.getElementById('postalCode');
		this.townValue = document.getElementById('town');
		this.foundCompaniesContainerView = document.getElementById(
			'foundCompaniesContainerView',
		);
		this.companyManualEntry = document.getElementById(
			'enterCompanyManualEntry',
		);

		const countrySelect = document.getElementById('countryIsoCode');
		this.countryIsoCode = countrySelect?.dataset.initialValue || '';
		this.validCompanyFieldName = 'validCompany';
		this.validAddressFieldName = 'validAddress';

		this.init();
	}

	init() {
		this.addressManualEntry?.setAttribute('hidden', '');
		this.setVisibility();

		this.enterDataManuallyButton?.addEventListener(
			'click',
			this.onManualButtonHandler.bind(this),
		);

		this.enterDataManuallyOnListButton?.addEventListener(
			'click',
			this.onManualButtonHandler.bind(this),
		);

		this.buttonBackToSearch?.addEventListener(
			'click',
			this.creditsafeCompanySearchFormVisibility.bind(this),
		);

		if (this.buttonBackToSearch) {
			this.toggleInputLabel();
		}
		creditsafeCompanySearchInput();
		this.creditsafeCompanySearchForm.addEventListener(
			'show-billing-address-form',
			this.showBillingAddressForm.bind(this),
		);

		window.addEventListener('popstate', this.onPopState.bind(this));
	}

	onManualButtonHandler(event) {
		event?.preventDefault();
		this.populateCompanyData(true);
	}

	showBillingAddressForm({ detail }) {
		this.populateCompanyData(false, detail);
	}

	setVisibility() {
		this.creditsafeCompanySearchForm.toggleAttribute(
			'hidden',
			!!this.countryIsoCode,
		);
		this.countrySelector.toggleAttribute('hidden', !this.countryIsoCode);
		this.billingForm.toggleAttribute('hidden', !this.countryIsoCode);
		// For non-default countries the Creditsafe search is skipped entirely, so
		// the manual entry form must be visible immediately without any user action.
		if (this.countryIsoCode) {
			this.addressManualEntry?.removeAttribute('hidden');
		}
	}

	setBillingFormVisibility() {
		this.countrySelector.toggleAttribute('hidden', false);
		this.creditsafeCompanySearchForm.toggleAttribute('hidden', true);
		this.billingForm.toggleAttribute('hidden', false);
		this.addressManualEntry.toggleAttribute('hidden', false);
		window.history.pushState({ view: 'billingForm' }, '');
	}

	populateCompanyData(isManual, companyDetail) {
		const countryCode = window?.dataLayer?.[0]?.navigation?.countryISO;
		this.setBillingFormVisibility();
		this.setBillingFormElementsVisibility(isManual);

		if (!isManual) {
			this.companyNameValue.value = companyDetail.companyName;
			if (this.chamberOfCommerceIdValue) {
				this.chamberOfCommerceIdValue.name = 'chamberOfCommerceId';
				this.chamberOfCommerceIdValue.value = (
					companyDetail.chamberOfCommerceId ?? ''
				).trim();
			}
			document.getElementById(
				'foundChamberOfCommerceIdCreditsafe',
			).textContent = (companyDetail.chamberOfCommerceId ?? '').trim();
			if (this.companyTaxNumberValue && companyDetail.companyTaxNumber) {
				this.companyTaxNumberValue.name = 'companyTaxNumber';
				this.companyTaxNumberValue.value = companyDetail.companyTaxNumber;
			}
			if (this.creditSafeConnectIdValue) {
				this.creditSafeConnectIdValue.name = 'creditSafeConnectId';
				this.creditSafeConnectIdValue.value = companyDetail.creditSafeConnectId;
			}
			if (this.creditCheckedCompanyIdValue) {
				this.creditCheckedCompanyIdValue.name = 'creditCheckedCompanyId';
				this.creditCheckedCompanyIdValue.value =
					companyDetail.creditCheckedCompanyId;
			}
			if (this.sicIdValue) {
				this.sicIdValue.name = 'sic';
				this.sicIdValue.value = this.getValueOrEmpty(companyDetail.sic);
			}
			if (this.validCompanyValue) {
				this.validCompanyValue.name = this.validCompanyFieldName;
				this.validCompanyValue.value = true;
			}
			this.postalCodeValue.value = companyDetail.postalCode || '';
			this.townValue.value = companyDetail.town || '';
			this.foundCompanyNameCreditsafe.textContent = companyDetail.companyName;

			if (
				countryCode === 'IE' ||
				countryCode === 'GB' ||
				countryCode === 'LU'
			) {
				this.address1Value.value = `${companyDetail.streetNumber || ''} ${
					companyDetail.streetName || ''
				}`.trim();
			} else {
				this.address1Value.value = `${companyDetail.streetName || ''} ${
					companyDetail.streetNumber || ''
				}`.trim();
			}

			const address2Input = document.getElementById('address2');
			if (address2Input) address2Input.value = '';

			const addressLines = CreditsafeCompanySearch.getFormattedAddressLines(
				countryCode,
				companyDetail,
			);

			[1, 2, 3, 4].forEach(index => {
				const el = document.getElementById(
					`foundAddressLine${index}Creditsafe`,
				);
				if (el) {
					el.textContent = addressLines[index - 1] || '';
				}
			});

			this.validateCreditsafeFields();
		} else {
			this.resetFieldsForManualInput();
		}

		if (!isManual) {
			this.resetAddressAlert();
		}
	}

	resetAddressAlert() {
		const addressAlert = this.billingForm?.querySelector(
			'.js-address-form-row.alert',
		);
		if (addressAlert) {
			addressAlert.classList.add('hidden');
			addressAlert
				.querySelector('.js-alert-box-text-first')
				?.classList.remove('hidden');
			addressAlert
				.querySelector('.js-alert-box-text-second')
				?.classList.add('hidden');
		}
	}

	static getFormattedAddressLines(countryCode, companyDetail) {
		const streetName = companyDetail.streetName || '';
		const streetNumber = companyDetail.streetNumber || '';
		const town = companyDetail.town || '';
		const postalCode = companyDetail.postalCode || '';
		const country = companyDetail.country || '';

		switch (countryCode) {
			case 'GB':
			case 'IE': {
				const streetLine = `${streetNumber} ${streetName}`.trim();
				const upperPostalCode = postalCode.toUpperCase();
				return [streetLine, town, upperPostalCode, country];
			}
			case 'DE':
			case 'AT':
			case 'CH':
			case 'BE': {
				const streetLine = `${streetName} ${streetNumber}`.trim();
				const postalTown = `${postalCode} ${town}`.trim();
				return [streetLine, postalTown, country, ''];
			}
			case 'NL': {
				const streetLine = `${streetName} ${streetNumber}`.trim();
				const upperPostalCode = postalCode.toUpperCase();
				const postalTown = `${upperPostalCode} ${town}`.trim();
				return [streetLine, postalTown, country, ''];
			}
			case 'LU': {
				const streetLine = `${streetNumber} ${streetName}`.trim();
				const postalTown = `${postalCode} ${town}`.trim();
				return [streetLine, postalTown, country, ''];
			}
			default: {
				const streetLine = `${streetName} ${streetNumber}`.trim();
				return [streetLine, town, postalCode, country];
			}
		}
	}

	validateCreditsafeFields() {
		const fieldsToValidate = [
			this.companyNameValue,
			this.address1Value,
			this.postalCodeValue,
			this.townValue,
			this.chamberOfCommerceIdValue,
		].filter(Boolean);

		fieldsToValidate.forEach(field => {
			field.dispatchEvent(new Event('blur', { bubbles: true }));
		});

		const errorCount = fieldsToValidate.reduce((count, field) => {
			const formGroup = field.closest('.form-group');
			const errorsEl = formGroup?.querySelector('.form-text-errors');
			return count + (errorsEl?.innerHTML.length > 0 ? 1 : 0);
		}, 0);

		if (errorCount > 0) {
			this.setBillingFormElementsVisibility(true);
			this.skipExperianSearch();
			this.invalidateCompany();
		} else if (this.validAddressValue) {
			this.validAddressValue.name = this.validAddressFieldName;
			this.validAddressValue.value = true;
		}
	}

	skipExperianSearch() {
		const searchSection = document.querySelector('.js-address-search-section');
		if (!searchSection) return;

		searchSection
			.querySelector('.js-address-search-block')
			?.classList.add('hidden');
		searchSection
			.querySelector('.js-default-address-static-card')
			?.classList.add('hidden');
		searchSection
			.querySelectorAll('.js-address-form-row')
			.forEach(row => row.classList.remove('hidden'));
	}

	invalidateCompany() {
		if (this.validAddressValue) {
			this.validAddressValue.value = false;
		}
		if (this.validCompanyValue) {
			this.validCompanyValue.value = false;
		}
	}

	resetFieldsForManualInput() {
		this.resetFields(
			[
				this.creditSafeConnectIdValue,
				this.creditCheckedCompanyIdValue,
				this.sicIdValue,
			],
			true,
		);

		this.resetFields([this.companyNameValue, this.chamberOfCommerceIdValue]);

		this.companyTaxNumberValue?.removeAttribute('name');

		if (this.validCompanyValue) {
			this.validCompanyValue.name = this.validCompanyFieldName;
			this.validCompanyValue.value = false;
		}

		if (this.validAddressValue) {
			this.validAddressValue.name = this.validAddressFieldName;
			this.validAddressValue.value = false;
		}
	}

	resetFields(fields, resetName = false) {
		fields.forEach(field => {
			if (field) {
				field.value = '';
				if (resetName) field.name = '';
			}
		});
	}

	getValueOrEmpty(str) {
		return str || '';
	}

	setBillingFormElementsVisibility(isManual) {
		this.foundCompaniesContainerView.toggleAttribute('hidden', isManual);
		this.relocateCompanyTaxNumber(isManual);
		const billingFormElements = [
			this.addressValidationContainer,
			this.addressCardContainer,
			this.address1Container,
			this.address2Container,
			this.countrySelector,
			this.postalCodeAndTownContainer,
			this.chamberOfCommerceIdContainer,
			this.companyManualEntry,
			this.addressManualEntry,
		];
		billingFormElements.forEach(element => {
			element?.toggleAttribute('hidden', !isManual);
		});

		if (!isManual) {
			document
				.querySelector('.js-default-address-static-card')
				?.classList.add('hidden');

			document
				.querySelector('.js-address-search-section')
				?.querySelectorAll('.js-address-form-row')
				.forEach(row => row.classList.add('hidden'));
		}
	}

	/**
	 * Moves the single companyTaxNumber (VAT) form-group between its original
	 * manual-block location and the Creditsafe found-company view slot.
	 * - Found company selected (isManual === false): VAT shown inside
	 *   #foundCompaniesContainerView via #foundCompanyTaxNumberSlot.
	 * - Manual entry (isManual === true): VAT returned next to the CRN field
	 *   in the manual company-details block.
	 * A no-op when the slot is absent (flip disabled / non-CH), so other flows
	 * are unaffected.
	 */
	relocateCompanyTaxNumber(isManual) {
		if (!this.companyTaxNumberGroup) return;

		const target =
			!isManual && this.foundCompanyTaxNumberSlot
				? this.foundCompanyTaxNumberSlot
				: this.companyTaxNumberOriginalParent;

		if (target && this.companyTaxNumberGroup.parentElement !== target) {
			target.appendChild(this.companyTaxNumberGroup);
		}
	}

	creditsafeCompanySearchFormVisibility(event) {
		event.preventDefault();

		this.showCompanySearch();
		window.history.back();
	}

	onPopState() {
		if (this.countryIsoCode) {
			return;
		}
		if (!this.billingForm?.hidden) {
			this.showCompanySearch();
		}
	}

	showCompanySearch() {
		this.countrySelector?.toggleAttribute('hidden', true);
		this.creditsafeCompanySearchForm?.toggleAttribute('hidden', false);
		this.billingForm?.toggleAttribute('hidden', true);
		this.addressManualEntry.toggleAttribute('hidden', true);

		document
			.querySelector('.js-default-address-static-card')
			?.classList.add('hidden');
		document
			.querySelector('.js-address-search-block')
			?.classList.remove('hidden');
		document
			.querySelector('.js-address-search-section')
			?.querySelectorAll('.js-address-form-row')
			.forEach(row => row.classList.add('hidden'));
	}

	toggleInputLabel() {
		const radioButtons = document.querySelectorAll('input[name="company"]');
		const textCompanyRegistration = document.getElementById(
			'textCompanyRegistration',
		);
		const textCompanyName = document.getElementById('textCompanyName');
		const searchBarCreditsafe = document.getElementById('searchBarCreditsafe');
		const placeholderElement = document.getElementById(
			'searchBarCreditsafePlaceHolder',
		);
		const searchBarCreditsafePlaceHolder = placeholderElement
			? placeholderElement.dataset.placeholder
			: '';
		const searchContainer = document.querySelector(
			'.creditsafe-company-search__search-container',
		);

		// Default state: search by name - hide button
		this.updateSearchMode(searchContainer, true);

		radioButtons?.forEach(radio => {
			radio.addEventListener('change', () => {
				searchBarCreditsafe.value = '';
				this.foundCompanyContainer.setAttribute('hidden', '');
				document.getElementById('errorMessageElement').textContent = '';
				if (radio.value === 'number' && radio.checked) {
					textCompanyRegistration.classList.remove('d-none');
					textCompanyName.classList.add('d-none');
					searchBarCreditsafe.placeholder = searchBarCreditsafePlaceHolder;
					this.updateSearchMode(searchContainer, false);
				} else if (radio.value === 'name' && radio.checked) {
					searchBarCreditsafe.placeholder = '';
					textCompanyRegistration.classList.add('d-none');
					textCompanyName.classList.remove('d-none');
					this.updateSearchMode(searchContainer, true);
				}
			});
		});
	}

	updateSearchMode(searchContainer, isSearchByName) {
		searchContainer?.classList.toggle(
			'creditsafe-company-search__search-container--search-by-name',
			isSearchByName,
		);
	}
}
